/* eslint-disable no-param-reassign */
import axios from 'axios';
import weui from 'weui.js';

import auth from '@/auth';
import router from '@/router';
import store from '@/store';
import conf from '@/config';

import { LOGOUT } from '@/store/auth/types';
import { ROUTE_LOGIN } from '@/router/names';

const requests = axios.create({
    baseURL: conf.api,
    headers: {
        Accept: 'application/json',
    },
});

requests.interceptors.request.use(
    (config) => {
        const token = auth.token();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error),
);

requests.interceptors.response.use(
    resp => resp,
    (error) => {
        const { status, data } = error.response;
        if (status === 401) {
            store.commit(`auth/${LOGOUT}`);
            router.push({
                name: ROUTE_LOGIN,
                query: {
                    redirect: router.currentRoute.fullPath,
                },
            });
        } else if (status === 422) {
            Object.entries(data.errors).forEach(([, errs]) => {
                errs.forEach(m => weui.topTips(m));
            });
            weui.topTips(data.message);
        } else if (data.message) {
            weui.topTips(data.message);
        }
    },
);

export default requests;



// WEBPACK FOOTER //
// ./src/api/requests.js